import { render } from "./ButtonV3.vue?vue&type=template&id=d2efe6be&scoped=true"
import script from "./ButtonV3.vue?vue&type=script&lang=js"
export * from "./ButtonV3.vue?vue&type=script&lang=js"

import "./ButtonV3.vue?vue&type=style&index=0&id=d2efe6be&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/rb-redev/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d2efe6be"]])

export default __exports__